// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the web app's origin for chat links (Copy link, mentions). RuntimeConfig needs the app's
// bootstrap as soon as it is imported, so it is loaded lazily here: the Agents store and the
// components that make links stay importable without it (unit tests). Until it has loaded, and
// where it can't, the page's own origin stands in (the same on the web).

import {chatMentionUrl} from '@app/features/konvo_agents/utils/AgentMentions';

let base: string | null = null;
// Only in the app itself (its bootstrap is there); elsewhere RuntimeConfig can't load.
if (typeof window !== 'undefined' && (window as {__FLUXER_BOOTSTRAP__?: unknown}).__FLUXER_BOOTSTRAP__)
	void import('@app/features/app/state/RuntimeConfig')
		.then((module) => {
			base = module.default.webAppBaseUrl;
		})
		.catch(() => undefined);

export function agentWebOrigin(): string {
	if (base) return base;
	return typeof location !== 'undefined' && location.origin && location.origin !== 'null' ? location.origin : '';
}

/** Where a Konvo chat link can point: the web app's origin and this page's. */
export function agentChatOrigins(): Array<string> {
	const origins = [agentWebOrigin()];
	if (typeof location !== 'undefined' && location.origin && location.origin !== 'null') origins.push(location.origin);
	return origins;
}

/** A chat's link for Copy link and mentions. */
export function agentChatLink(machineId: string, threadId: string): string {
	return chatMentionUrl(agentWebOrigin(), machineId, threadId);
}
